import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerWebComponent } from '@boschebike/ebds-js';
const initReactWebComponent = (Component, mountPoint) => {
  const root = createRoot(mountPoint);
  root.render(/*#__PURE__*/React.createElement(Component, null));
};

/* eslint-disable max-len */

/**
 * Registers a web component and handles all the logic with registering a web component
 * that is rendering a React component.
 *
 * @param {string} name CustomHtmlElement name (e.g. "some-slug" becomes "<some-slug>"
 * @param {Function} Component react component
 * @param {Object} options
 * @param {"open", "closed", undefined, false} options.shadow type of shadow dom, falsy value disables shadow dom
 * @param {string="display: block; width: 100%"} mountPointStyle web component wrapper style
 */
const registerReactAsCustomHtmlElementPage = (name, Component, {
  shadow = 'closed',
  mountPointStyle = 'display: block; width: 100%'
} = {}) => {
  class AdHocCustomHtmlElement extends HTMLElement {
    connectedCallback() {
      let shadowBackwardsCompat = shadow;
      // Previously it was true or false. When true it was closed shadow.
      if (shadow === true) {
        console.log('Please migrate shadow prop to either: "open", "closed" or falsy to not use shadow dom.');
        shadowBackwardsCompat = 'closed';
      }
      const mountPoint = document.createElement('div');
      mountPoint.style = mountPointStyle;
      if (shadowBackwardsCompat) {
        this.attachShadow({
          mode: shadowBackwardsCompat
        }).appendChild(mountPoint);
      } else {
        this.appendChild(mountPoint);
      }
      initReactWebComponent(Component, mountPoint);
    }
  }
  registerWebComponent(name, AdHocCustomHtmlElement);
};
export default registerReactAsCustomHtmlElementPage;